/**
 * Apply Button - Listing action for applications
 *
 * Neutral outlined button for application actions. Can be used in
 * footers, cards, CTAs, or any context where application functionality
 * is needed.
 */

import { Button } from '../../../ui/Button';

/**
 * Props for listing action buttons
 */
export type ListingActionButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

/**
 * Apply Button Component
 *
 * @example
 * <ApplyButton
 *   onClick={() => startApplication(listing)}
 * />
 */
export const ApplyButton = ({ onClick, disabled = false }: ListingActionButtonProps) => (
  <Button shape="rectangle" tone="neutral" emphasis="outlined" fluid={true} onClick={onClick} disabled={disabled}>
    Apply
  </Button>
);
